import { render, staticRenderFns } from "./NamedMembers.vue?vue&type=template&id=2aa75bf0&"
import script from "./NamedMembers.vue?vue&type=script&lang=ts&"
export * from "./NamedMembers.vue?vue&type=script&lang=ts&"
import style0 from "./NamedMembers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports